// Enhanced MultiplierTooltipContent component
import React from 'react'
import { Award, Star, TrendingUp } from 'react-feather'

import {
  HeaderIcon,
  MultiplierDivider,
  MultiplierDot,
  MultiplierHeader,
  MultiplierItem,
  MultipliersContainer,
  MultiplierText,
  MultiplierTooltipContainer,
} from './styled'

interface MultiplierTooltipContentProps {
  title?: string
  multipliers?: string[]
}

export const MultiplierTooltipContent: React.FC<MultiplierTooltipContentProps> = ({ title, multipliers }) => {
  if (!multipliers || multipliers.length === 0) return null

  return (
    <MultiplierTooltipContainer>
      <MultiplierHeader>
        <HeaderIcon>
          {title?.includes('YT') ? (
            <Award size={18} />
          ) : title?.includes('Reward') ? (
            <Star size={18} />
          ) : (
            <TrendingUp size={18} />
          )}
        </HeaderIcon>
        {title || 'Multipliers'}
      </MultiplierHeader>

      <MultiplierDivider />

      <MultipliersContainer>
        {multipliers.map((multiplier, index) => (
          <MultiplierItem key={index}>
            <MultiplierDot />
            <MultiplierText>{multiplier}</MultiplierText>
          </MultiplierItem>
        ))}
      </MultipliersContainer>
    </MultiplierTooltipContainer>
  )
}

export default MultiplierTooltipContent
